// import DesignerTextBox from '../ContentItems/DesignerTextBox';
import AllContents from '../ContentItems/AllContents';
import * as EditorHelpers from '../utilities/EditorHelpers';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as DimensionsFns from '../utilities/DimensionsFns';
import * as CoreFns from '../utilities/CoreFns';
import * as HolderWrapperFn from '../ContentItems/HolderWrapperFn';

//
export  function goThroughItems(items, chains, isAbsolute, panelPath, interactionFn, itemEdited, setItemEdited, isDraggingDetails, insetWidth, insetHeight, dragStart, dragEnd, onDrag, isShowingSomeDropDown, currentList, otherPeoplesPositions, updatesToPropagate, organicChanges, userNos, userID, getRef1, refObject, error, internalVariables, clickEditItem, onClickItemChangeSelection, inputValues, setInputValues, ownVariables, urlParamsForExecution, urlHeader,  setIsShowingSomeDropDown, setIsClickingOnContentDiv, upwardInfo, isClickingOnContentDiv, addWhereText, potentiallyAddWhichItem, hoveringWhere, actHoveringWhere, screenSelectionChoices, setScreenSelectionChoices, popUps, setPopUps, showItems, doAScreenRef, flashHighlight, lastEdited, counter){

    function getLocFromDimensions(t, v, changeWhat){
      return EditorHelpers.reverseScale(v, t, changeWhat, insetWidth, insetHeight);
    }

    var pointer = 'k';
    if (isAbsolute){
      pointer = 'i';
    }

    var itemKeys = [];
    if (items){
      if (!isAbsolute){
        itemKeys = ResponsiveFns.sortAListBasedOnOrd(items);
      }else{
        itemKeys = Object.keys(items);
      }      
    }
    var choices = [];
    var expressedItemsIn = itemKeys.map((anItemKey, index)=>{

      var anItem = items[anItemKey];
      var itemPath = panelPath.concat([pointer, anItemKey]);

      var isPieceEdited = false;
      if (!interactionFn){
        if (!interactionFn && itemEdited && itemEdited.t === 'item' && itemEdited.path.join(' ') === itemPath.join(' ')){
          isPieceEdited = true;
        } 
      }


      var s = {};
      var dragStuff = null;
      if (isAbsolute){
        var pos = anItem.pos;

        var considerationSet = EditorHelpers.getConsiderationSet(pos, isPieceEdited, isDraggingDetails, insetWidth, insetHeight, anItem);
        s = {position:'absolute'};

        var ss = DimensionsFns.getLeftRightWidthFromPosAndValues(pos, considerationSet.lv, considerationSet.wv, considerationSet.rv, insetWidth, insetHeight);

        s.left = ss.left;
        s.right = ss.right;
        s.width = ss.width;

        // if (pos.lr.v === 0 || pos.lr.v === 1){
        //   s.left = getLocFromDimensions(pos.l.t, considerationSet.lv, 'l');
        // }
        // if (pos.lr.v === 0 || pos.lr.v === 2){
        //   s.width = getLocFromDimensions(pos.w.t, considerationSet.wv, 'w');
        // }
        // if (pos.lr.v === 1 || pos.lr.v === 2){
        //   s.right = getLocFromDimensions(pos.r.t, considerationSet.rv, 'r');
        // }

        // if (pos.lr.v === 1){ //this is needed for picture mode as we need to specify width.
        //   s.width = insetWidth - s.left - s.right;
        // }

        if (pos.ud.v === 0 || pos.ud.v === 1 || pos.ud.v === 3 || pos.ud.v === 5){
          s.top = getLocFromDimensions(pos.t.t, considerationSet.tv, 't');
        }
        if (pos.ud.v === 0 || pos.ud.v === 2){
          s.height = getLocFromDimensions(pos.h.t, considerationSet.hv, 'h');
        }
        if (pos.ud.v === 1 || pos.ud.v === 2 || pos.ud.v === 4 || pos.ud.v === 6){
          s.bottom = getLocFromDimensions(pos.b.t, considerationSet.bv, 'b');
        }

        var limits = [{t:'minWidth', v:'w'}, {t:'maxWidth', v:'w'}, {t:'minHeight', v:'h'}, {t:'maxHeight', v:'h'}]
        limits.forEach((aLimit, index)=>{
          if (pos[aLimit.t]){
            s[aLimit.t] = getLocFromDimensions(pos[aLimit.t].t, pos[aLimit.t].v, aLimit.v);
          }
        })


        if (pos.ud.v === 3 || pos.ud.v === 4){
          s.oH = considerationSet.oHv;
          s.oW = considerationSet.oWv;
          s.cT = considerationSet.cTv;
          s.cL = considerationSet.cLv;
          s.cR = considerationSet.cRv;
          s.cB = considerationSet.cBv;      
          s.sca = considerationSet.sca;
          //so we also amend width, left, right based on results haha. shack. top too.
          // var infoOut = doInfoOverride(info, isPieceEdited, isDraggingDetails, insetWidth, insetHeight);
        }


        if (!interactionFn){
          if (isPieceEdited){
            if (anItem.t === 'SUMMARYDIV' || anItem.t === 'RADIO'){
            }else{
              dragStuff = {dragStart, onDrag, dragEnd};
            }
          }else if (anItem.t === 'DIV' || anItem.t === 'RADIO' || anItem.t === 'CARD' || anItem.t === 'CONTAINER' || anItem.t === 'HFLEX' || anItem.t === 'SUMMARY' || anItem.t === 'SUMMARYDIV' ){
          }else{
            dragStuff = {dragStart, onDrag, dragEnd};
          }            
        }


        if (isPieceEdited){
          
          var mvLeft; var mvWidth; var mvTop; var mvHeight;
          if (pos.lr.v === 0 || pos.lr.v === 1){
            mvLeft = s.left;
          }else{
            mvLeft = insetWidth - s.right - s.width;
          }
          if (pos.lr.v === 0 || pos.lr.v === 2){
            mvWidth = s.width;
          }else{
            mvWidth = insetWidth - s.left - s.right;
          }

          if (pos.ud.v === 5){
            choices = [{t:'leftTop', left:mvLeft, top:s.top}, {t:'rightTop', left:mvLeft + mvWidth, top:s.top}];
          }else if (pos.ud.v === 6){
            choices = [{t:'leftBottom', left:mvLeft, bottom:s.bottom}, {t:'rightBottom', left:mvLeft + mvWidth, bottom:s.bottom}];
          }else{
            if (pos.ud.v === 0 || pos.ud.v === 2){
              mvHeight = s.height;
            }else if (pos.ud.v === 1){
              mvHeight = insetHeight - s.top - s.bottom;
            }else if (pos.ud.v === 3 || pos.ud.v === 4){
              mvHeight = s.width * s.sca * (s.oH - s.cT - s.cB) / (s.oW - s.cL - s.cR);
            }

            if (pos.ud.v === 0 || pos.ud.v === 1 || pos.ud.v === 3){
              mvTop = s.top;
            }else if (pos.ud.v === 4){
              mvTop = insetHeight - s.bottom - mvHeight;
            }else{
              mvTop = insetHeight - s.bottom - s.height;
            }

            choices = [{t:'leftTop', left:mvLeft, top:mvTop}, {t:'rightBottom', left:mvLeft + mvWidth, top:mvTop + mvHeight}];

            if (pos.ud.v === 3 || pos.ud.v === 4){
            }else{
              choices.push({t:'rightTop', left:mvLeft + mvWidth, top:mvTop});
              choices.push({t:'leftBottom', left:mvLeft, top:mvTop + mvHeight});
            }        
          }
        }

      }

      if (!interactionFn && !isAbsolute){
        if (isPieceEdited){

          function oDragStart(){
            return function(e){
              itemEdited.d = true;
              setItemEdited({...itemEdited})
            }
          }

          function oDragEnd(e){
            delete itemEdited.d;
            setItemEdited({...itemEdited})
          }

          function oDrag(e){
          }
          dragStuff = {dragStart:oDragStart, onDrag:oDrag, dragEnd:oDragEnd};
        }
      }
        
      if(!showItems){
        s.visibility = 'hidden';
      }
  //    

        var editPieces = {getRef1, refObject, updatesToPropagate, organicChanges, onClickItemChangeSelection, error, otherPeoplesPositions};

        return (<AllContents userID={userID} chains={chains} height={insetHeight} width={insetWidth} currentList={currentList} internalVariables={internalVariables} interactionFn={interactionFn} inputValues={inputValues} setInputValues={setInputValues} itemEdited={itemEdited} setItemEdited={setItemEdited} thisItem={anItem} itemInfoPath={itemPath} stylesToAdd={s} clickEditItem={clickEditItem} editPieces={editPieces} needToShowError={false} addClassNames={''} dragStuff={dragStuff} parentalType={''} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} upwardInfo={upwardInfo} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} organicChanges={organicChanges} userNos={userNos} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices}  popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} doAScreenRef={doAScreenRef} flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>)

      // }
    })

  var expressedItems;

  if (itemEdited && !isAbsolute && itemEdited.t === 'item' && CoreFns.goDownPath(currentList, itemEdited.path) && CoreFns.goDownPath(currentList, itemEdited.path).t === 'CONTAINER'){
    expressedItems = HolderWrapperFn.doActualWrap(itemKeys, panelPath, 'k', itemEdited, setItemEdited, currentList, organicChanges, 'containerMain', expressedItemsIn, insetWidth)
  }else{
   expressedItems = expressedItemsIn;
  }

    return {expressedItems, choices};
  }

